/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  var old_models = [
    mp.marketing.trends.utils.IPHONE_XS,
    mp.marketing.trends.utils.IPHONE_XS_MAX,
    mp.marketing.trends.utils.IPHONE_XR,
    mp.marketing.trends.utils.OTHER_IPHONE,
  ];
  var release_models = [
    mp.marketing.trends.utils.IPHONE_SE_2ND_GEN,
    mp.marketing.trends.utils.IPHONE_11_PRO_MAX,
    mp.marketing.trends.utils.IPHONE_11_PRO,
    mp.marketing.trends.utils.IPHONE_11,
  ];
  var IPhone11 = mp.marketing.trends.widgets.PhoneAdoption.extend({
    get_display_models() {
      return release_models.concat(old_models);
    },
    get_release_models() {
      return release_models;
    },
    get_visible_models() {
      return release_models.concat(old_models.slice(0, 3));
    },
    get_query_name() {
      return mp.marketing.trends.utils.IPHONE_QUERY;
    },
    getDownloadName() {
      return ns.IPhone11.nice_name;
    },
  });

  Object.assign(IPhone11, {
    slug: `iphone_11`,
    nice_name: `iPhone 11, 11 Pro, and 11 Pro Max adoption`,
    description: `How quickly will people start using the new iPhone 11, iPhone 11 Pro, or iPhone 11 Pro Max?`,
  });
  ns.IPhone11 = IPhone11;
});

}.call(window));